import React from 'react';
import { Form, Input, Button, Row, Col, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const ChangePasswordForm: React.FC = () => {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      await api.post('/profile/change-password', {
        old_password: values.old_password,
        new_password: values.new_password,
      });

      message.success('Password berhasil diubah.');
      form.resetFields();

      // Redirect to dashboard after a short delay to let user see the message
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);

    } catch (error: any) {
      console.error('Failed to change password:', error);
      message.error(error.response?.data?.message || 'Gagal mengubah password.');
    }
  };

  return (
    <Row justify="center">
      <Col xs={24} sm={20} md={16} lg={12}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="old_password"
            label="Password Saat Ini"
            rules={[{ required: true, message: 'Password saat ini wajib diisi!' }]}
          >
            <Input.Password placeholder="Masukkan password Anda saat ini" />
          </Form.Item>

          <Form.Item
            name="new_password"
            label="Password Baru"
            rules={[
              { required: true, message: 'Password baru wajib diisi!' },
              { min: 6, message: 'Password minimal 6 karakter.' },
            ]}
            hasFeedback
          >
            <Input.Password placeholder="Masukkan password baru Anda" />
          </Form.Item>

          <Form.Item
            name="confirm_password"
            label="Konfirmasi Password Baru"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              { required: true, message: 'Mohon konfirmasi password baru Anda!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Konfirmasi password tidak cocok!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Ketik ulang password baru Anda" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Ubah Password
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default ChangePasswordForm;
